import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="openas"
// Combined group/user "Open as" dropdown: sets the hidden group/openas inputs and updates the
// trigger label. Works with the classic Bootstrap dropdown (finds the data-bs-toggle trigger)
// AND the new-UI tw-dropdown (uses a `label` target + a defaultLabel value, and closes the
// tw-dropdown menu after a selection since Bootstrap is no longer doing that).
export default class extends Controller {
  static targets = ["group", "user", "label"]
  static values = { defaultLabel: String }

  selectGroup(event) {
    event.preventDefault()
    this.groupTarget.value = event.currentTarget.dataset.value
    this.userTarget.value = ""
    this.updateLabel(event.currentTarget.textContent.trim())
    this.closeMenu(event)
  }

  selectUser(event) {
    event.preventDefault()
    this.userTarget.value = event.currentTarget.dataset.value
    this.groupTarget.value = ""
    this.updateLabel(event.currentTarget.textContent.trim())
    this.closeMenu(event)
  }

  clear(event) {
    event.preventDefault()
    this.groupTarget.value = ""
    this.userTarget.value = ""
    this.updateLabel(this.defaultLabel)
    this.closeMenu(event)
  }

  get bootstrapToggle() {
    return this.element.closest(".dropdown")?.querySelector('[data-bs-toggle="dropdown"]')
  }

  get defaultLabel() {
    if (this.hasDefaultLabelValue && this.defaultLabelValue) return this.defaultLabelValue
    return this.bootstrapToggle?.dataset.defaultLabel || "Open as..."
  }

  updateLabel(name) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = name
    } else if (this.bootstrapToggle) {
      this.bootstrapToggle.innerHTML = '<i class="fa-solid fa-user"></i> ' + name
    }
  }

  // New UI only: Bootstrap auto-closed its menu on item click; tw-dropdown doesn't, so close it.
  closeMenu(event) {
    event.currentTarget
      .closest('[data-controller~="tw-dropdown"]')
      ?.querySelector('[data-tw-dropdown-target="menu"]')
      ?.classList.add("hidden")
  }
}
